import ProfileSideMenuWrapper from 'modules/navigation/components/ProfileSideMenuWrapper';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import NightlyCountPageTabs from '../../components/NightlyCountPageTabs';

const NightlyCountPage: FC = () => {
  const { t } = useTranslation('nightlyCount.NightlyCountPage');
  return (
    <ProfileSideMenuWrapper title={t('nightlyCount')}>
      <NightlyCountPageTabs />
    </ProfileSideMenuWrapper>
  );
};

export default NightlyCountPage;
